"use client";

import { useTransition } from "react";
import { useRouter } from "next/navigation";
import { canUseLocalStorage, newLocalId } from "@/lib/drafts/local-draft";
import { cn } from "@/lib/utils";

export function StartButton({ className }: { className?: string } = {}) {
  const router = useRouter();
  const [pending, startTransition] = useTransition();

  const onClick = () => {
    startTransition(() => {
      if (!canUseLocalStorage()) {
        router.push("/signup?reason=no-storage");
        return;
      }
      const id = newLocalId();
      router.push(`/offerings/draft#draft=${id}`);
    });
  };

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={pending}
      className={cn(
        "inline-flex items-center justify-center rounded-full",
        "bg-terracotta text-white font-medium",
        "px-10 py-5 text-lg md:text-xl",
        "shadow-[0_8px_24px_-8px_rgba(168,85,55,0.55)]",
        "transition-all duration-200",
        "hover:-translate-y-0.5 hover:shadow-[0_12px_32px_-8px_rgba(168,85,55,0.65)]",
        "active:translate-y-0",
        "disabled:opacity-60 disabled:hover:translate-y-0",
        className
      )}
    >
      {pending ? "Opening editor…" : "Make a sign-up page →"}
    </button>
  );
}
